import React from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import OldStyleSection from '../common/oldStyleSection';
import ExcelExportButton from '../common/excelExportButton';
import OldStyleTableWithHistory from '../common/oldStyleTableWithHistory';
import FinColumnOrderManager from './finStatements/finColumnOrderManager';
import { reportActions } from '../../store/reportStore';

import './finStatements/finStatements.scss';

class FinRatiosData extends React.Component {
    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        const info = this.props.getSection([this.props.sectionId]);
        let ascending = false;
        if (info.params != null && info.params.ascending != null) ascending = info.params.ascending;
        return this.props.data === undefined || this.props.data === null ? null : <div>{this.renderContent(this.props.data, ascending)}</div>;
    }

    renderContent = (data, ascending) => {
        if (data.country == null)
            return null;

        if (data.country.toUpperCase() === "SK") {
            return (
                <>
                    <FinColumnOrderManager sectionId={this.props.sectionId}/>
                    {data.hasRatiosLevel1 && this.renderSkTable("Report.FinancialRatios.Liquidity", data.ratiosLevel1, data.statements)}
                    {data.hasRatiosLevel2 && this.renderSkTable("Report.FinancialRatios.Activity", data.ratiosLevel2, data.statements)}
                    {data.hasRatiosLevel3 && this.renderSkTable("Report.FinancialRatios.Indebtness", data.ratiosLevel3, data.statements)}
                    {data.hasRatiosLevel4 && this.renderSkTable("Report.FinancialRatios.RentabilityAndEffectivity", data.ratiosLevel4, data.statements)}
                    {data.statements.filter(s => s.isIncorrect === true).length > 0 &&
                        <div className="fin-stmt-incorrect-legend">*&nbsp;<Translate id="Report.FinancialStatements.IncorrectLegend" /></div>}
                    <ExcelExportButton link="fin-ratios" entityId={this.props.id} report={this.props.reportType} ascending={ascending} />
                </>
            );
        }
        if (data.country.toUpperCase() === "CZ") {
            const hasData = data.hasRatiosLevel1 || data.hasRatiosLevel2 || data.hasRatiosLevel3;
            return (
                <>
                    <FinColumnOrderManager sectionId={this.props.sectionId} />
                    <OldStyleSection name={<Translate id="Report.FinancialRatios.FinancialIndicatorsSection" />} hasData={hasData} isBold>
                        <div style={{ marginLeft: "2.5em", paddingTop: "0.25em" }}>
                            {data.hasRatiosLevel1 && this.renderCzTable("Report.FinancialRatios.ProductivityIndicators", data.ratiosLevel1, data.statements,
                                'Report.FinancialStatements.PeriodFrom', 'Report.FinancialStatements.PeriodTo', false, false)}
                            {data.hasRatiosLevel2 && this.renderCzTable("Report.FinancialRatios.FinancialIndicators", data.ratiosLevel2, data.statements,
                                'Report.FinancialStatements.PeriodFrom', 'Report.FinancialStatements.PeriodTo', false, false)}
                            {data.hasRatiosLevel3 && this.renderCzTable("Report.FinancialRatios.WorkingCapital", data.ratiosLevel3, data.statements,
                                'Report.FinancialStatements.PeriodFrom', 'Report.FinancialStatements.PeriodTo', false, false)}
                        </div>
                    </OldStyleSection>
                    <OldStyleSection name={<Translate id="Report.FinancialRatios.FinancialIndicatorsTrendsSection" />} hasData={hasData} isBold>
                        <div style={{ marginLeft: "2.5em", paddingTop: "0.25em" }}>
                            {data.hasRatiosTrendsLevel1 && this.renderCzTable("Report.FinancialRatios.ProductivityIndicators", data.ratiosTrendsLevel1, data.statements,
                                'Report.FinancialRatios.EndOfFirstPeriod', 'Report.FinancialRatios.EndOfSecondPeriod', true, true)}
                            {data.hasRatiosTrendsLevel2 && this.renderCzTable("Report.FinancialRatios.FinancialIndicators", data.ratiosTrendsLevel2, data.statements,
                                'Report.FinancialRatios.EndOfFirstPeriod', 'Report.FinancialRatios.EndOfSecondPeriod', true, true)}
                            {data.hasRatiosTrendsLevel3 && this.renderCzTable("Report.FinancialRatios.WorkingCapital", data.ratiosTrendsLevel3, data.statements,
                                'Report.FinancialRatios.EndOfFirstPeriod', 'Report.FinancialRatios.EndOfSecondPeriod', true, true)}
                        </div>
                    </OldStyleSection>
                    {data.statements.filter(s => s.isIfrs).length > 0
                        ? <div className="fin-stmt-ifrs-legend">*&nbsp;<Translate id="Report.FinancialStatements.IfrsLegend" /></div>
                        : null}
                    <ExcelExportButton link="fin-ratios" entityId={this.props.id} report={this.props.reportType} ascending={ascending}/>
                </>
            );
        }
        return null;
    }

    renderSkTable = (name, items, statements) => {
        return (
            <OldStyleSection name={this.props.translate(name)} hasData={items.length > 0} isOpen isBold>
                <div style={{ paddingTop: "0.25em" }}></div>
                <OldStyleTableWithHistory tableColumns={7} classNames={{ "fin-stmt-table-first": true }}
                    head={() => this.renderSkTableHead(statements)} stripped
                    actualData={items}
                    actualRow={(r) => this.renderSkTableRow(r)}
                />
            </OldStyleSection>
        );
    }

    renderSkTableHead = (statements) => {
        return (
            <thead>
                <tr>
                    <th className="fin-ratios-item-name" ><Translate id="Report.FinancialStatements.ItemName" /></th>
                    <th className="fin-ratios-unit"><Translate id="Report.FinancialRatios.Unit" /></th>
                    {statements.map(s =>
                        <th key={s.id} className="fin-stmt-right" style={{ minWidth: "8em", textAlign: "right" }}>
                            {s.endDate}{s.isIncorrect && <span className="fin-stmt-type-sk">&nbsp;*</span>}
                        </th>
                    )}
                </tr>
            </thead>
        );
    }

    renderSkTableRow = (r) => {
        return (
            <tr key={r.rowId} className="fin-stmt-row">
                <td>{r.description}</td>
                <td>{r.unit}</td>
                {r.values.map(rv => <td className={classnames("fin-stmt-value", { "incorrect": rv.incorrect, "inherit": !rv.incorrect })} key={rv.rowId}>{rv.value}</td>)}
            </tr>
        );
    }

    renderCzTable = (name, items, statements, fromLabel, toLabel, isTrendsSection, headerWoodoo) => {
        return (
            <OldStyleSection name={this.props.translate(name)} hasData={items.length > 0} isOpen isBold>
                <div style={{ paddingTop: "0.25em" }}></div>
                <OldStyleTableWithHistory tableColumns={headerWoodoo ? 5 : 6} classNames={{ "fin-stmt-table-first": true }}
                    head={() => this.renderCzTableHead(statements, fromLabel, toLabel, isTrendsSection, headerWoodoo)}
                    actualData={items} stripped
                    actualRow={(r) => this.renderCzTableRow(r, false)}
                />
            </OldStyleSection>
        );
    }

    renderCzTableHead = (statements, fromLabel, toLabel, isTrendsSection, headerWoodoo) => {
        return (
            <thead>
                <tr style={{ borderBottom: "none" }}>
                    <th className="fin-ration-date" style={{ textAlign: "right" }}><Translate id={fromLabel} />:</th>
                    {!headerWoodoo && statements.map(s => <th key={s.id} className="fin-stmt-right">{isTrendsSection ? s.endDate : s.startDate}</th>)}
                    {headerWoodoo && statements.slice(1, statements.length).map(s => <th key={s.id} className="fin-stmt-right">{isTrendsSection ? s.endDate : s.startDate}</th>)}
                </tr>
                <tr style={{ borderTop: "none" }}>
                    <th className="fin-ration-date"  style={{ textAlign: "right" }}><Translate id={toLabel} />:</th>
                    {!headerWoodoo && statements.map(s =>
                        <th key={s.id} className="fin-stmt-right">
                            {s.endDate}
                            {s.isIfrs ? <span className="fin-stmt-type-cz">&nbsp;*</span> : null}
                        </th>
                    )}
                    {headerWoodoo && statements.slice(0, statements.length - 1).map(s =>
                        <th key={s.id} className="fin-stmt-right">
                            {s.endDate}
                            {s.isIfrs ? <span className="fin-stmt-type-cz">&nbsp;*</span> : null}
                        </th>
                    )}
                </tr>
            </thead>
        );
    }

    renderCzTableRow = (r) => {
        return (
            <tr key={r.rowId} className="fin-stmt-row">
                <td>{r.description}</td>
                {r.values.map(rv => <td key={rv.rowId} className={classnames("fin-stmt-value", {
                    "incorrect": rv.incorrect,
                    "ifrs": rv.isIfrs, 
                    "inherit": !rv.incorrect && !rv.isIfrs
                })}>{rv.value}</td>)}
            </tr>
        );
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(FinRatiosData));